import api from ".";


export default {
    addPhone: (phone) => {
        const res = api.post(`/api/phone/add`, { phone });
        return res;
    },
    verifyPhone: (phone, code) => {
        const res = api.post(`/api/phone/verify`, { phone, code });
        return res;
    },
    resendPhone: (phone) => {
        const res = api.post(`/api/phone/verify/resend`, { phone });
        return res;
    },
    newPhone: (phone) => {
        const res = api.post(`/api/phone/verify/new-phone`, { phone });
        return res;
    },
}